import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_TOKEN_EXPIRED',
    statusCode: 401,
    message: {
        en: 'Token Expired',
    },
} as CustomErrorType;